module.exports = __webpack_public_path__ + "img/puzzle_4.cc546ef5.png";